import ApiService from '@/services/api.service'


const CalendarResTimeAllocationDetails = {
    getAll(parameter){
        const params = {
            PageNumber         : parameter.PageNumber,
            PageSize           : parameter.PageSize,
            SearchCriteria     : parameter.SearchCriteria,
            Groupcreationid    : parameter.Groupcreationid
        }
        return ApiService.getWithArray('/CalendarResTimeAllocationDetails',params);
    },

  Add(data){
    return ApiService.post(`/CalendarResTimeAllocationDetails`, data);
  },
  Delete(Id){
    return ApiService.delete(`/CalendarResTimeAllocationDetails/${Id}`);
  },
  Update(Id,data){
    return ApiService.put(`/CalendarResTimeAllocationDetails/${Id}`,data);
  },
  UpdateMultiple(data){
    return ApiService.put(`/CalendarResTimeAllocationDetails/UpdateMultiple/`,data);
  },
  Get(Id){
    return ApiService.get(`/CalendarResTimeAllocationDetails/${Id}`);
  },

}

  export default CalendarResTimeAllocationDetails;
